import { useMatch } from '../MatchProvider';
import { MatchCellButton } from './MatchCellIButton';
import { useMatchDetails } from '../details/MatchDetailsProvider';

export const CellButtonDetails: React.FC = () => {
  const match = useMatch();
  const { populate } = useMatchDetails();

  return (
    <MatchCellButton
      onClick={() => {
        return populate(match);
      }}
    />
  );
};
